import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstBusinessSlice = createSlice({
    name: "getAllMstBusiness",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstBusinessSlice_actions = getAllMstBusinessSlice.actions;
export var fetchData = _getAllMstBusinessSlice_actions.fetchData, fetchDataSuccess = _getAllMstBusinessSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstBusinessSlice_actions.fetchDataFailure, resetState = _getAllMstBusinessSlice_actions.resetState;
export default getAllMstBusinessSlice.reducer;
